module.exports = __webpack_public_path__ + "img/strangeanimals.5e526c5c.png";